import { render, staticRenderFns } from "./property-statistics.vue?vue&type=template&id=10e07c4c&scoped=true&"
import script from "./property-statistics.vue?vue&type=script&lang=js&"
export * from "./property-statistics.vue?vue&type=script&lang=js&"
import style0 from "./property-statistics.vue?vue&type=style&index=0&id=10e07c4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e07c4c",
  null
  
)

export default component.exports